/**
 * Route Types - Constants for DB-first routing
 * 
 * Minimal type definitions for the deterministic routing system.
 * All slug resolution goes through database queries via 
 * useSlugResolver and useTwoSegmentResolver.
 */

// ============================================================================
// ACCOUNT SUBROUTES
// ============================================================================

/**
 * Account subroutes (static segment2 values)
 * Used by useTwoSegmentResolver to identify account sub-pages
 */
export const ACCOUNT_SUBROUTES = new Set([
  'profile',
  'preferences',
  'publications',
  'favorites',
  'membership',
  'chats',
  'comments',
  'media',
  'performance',
  'opportunities',
]);
